import { openZohoChat } from '../utils/openZohoChat';

/** Sticky mobile chat CTA — opens Zoho SalesIQ. */
export default function FixedChatBar() {
  return (
    <div className="fm-chatbar" role="region" aria-label="Live chat">
      <button type="button" className="fm-chatbar__btn" onClick={openZohoChat}>
        <span className="fm-chatbar__dot" aria-hidden />
        Chat with us — get a free quote
      </button>
    </div>
  );
}
